import React, { useEffect, useState } from "react";
import OtpInput from "react-otp-input";
import { Button } from "../../../components";
import { toast } from "react-toastify";

const OtpModule = ({ phone, handleSubmit, sendOtp, loading, otpError, clearOtpError }) => {
  const [otp, setOtp] = useState("");
  const [timer, setTimer] = useState(60);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimer((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const handleOtpChange = (value) => {
    setOtp(value);
    if (clearOtpError) {
      clearOtpError();
    }
  };

  const handleResend = async () => {
    if (clearOtpError) {
      clearOtpError();
    }
    try {
      await sendOtp(phone, "resend");
      setTimer(60);
      toast.success("New OTP sent to your WhatsApp number.");
    } catch (error) {
      console.log("Failed to resend OTP", error?.message);
    }
  };

  return (
    <form
      onSubmit={(e) => handleSubmit(e, otp)}
      className="otp-wrapper wid-100 relative flex flex-col gap-3"
    >
      <h3 className="text-xl font-extrabold text-[#111827] tracking-tight leading-tight mb-0">
        Verify Your Phone Number
      </h3>
      <p className="text-sm text-gray-500 font-medium mb-2">
        Enter the 6-digit OTP code sent to WhatsApp ending in <span className="font-bold text-gray-700">*******{phone?.slice(-4)}</span>
      </p>

      <div className="w-full otp-main-card">
        <div className="flex-1 form-group otp-card">
          <OtpInput
            value={otp}
            onChange={handleOtpChange}
            numInputs={6}
            renderSeparator={<span>&nbsp;&nbsp;&nbsp;</span>}
            shouldAutoFocus
            renderInput={(props) => <input className="!px-5" {...props} />}
          />
          {otpError && (
            <div className="text-xs text-[#f00] font-semibold mt-2 text-left">
              {otpError}
            </div>
          )}
        </div>
      </div>

      <div className="mt-2">
        <Button
          version="secondary"
          text="Verify & Continue"
          type="submit"
          loading={loading}
          width="100%"
          className="w-full justify-center font-extrabold"
        />
      </div>

      <div className="flex justify-between items-center text-xs sm:text-sm font-bold mt-2 select-none w-full">
        <span className="text-gray-600">Didn’t receive OTP?</span>
        <div>
          {timer > 0 ? (
            <span className="text-gray-400 font-semibold">Resend in {timer}s</span>
          ) : (
            <button
              type="button"
              onClick={handleResend}
              className="text-[#009DFF] hover:underline cursor-pointer font-bold bg-transparent border-0 p-0 outline-none"
            >
              Resend Code
            </button>
          )}
        </div>
      </div>
    </form>
  );
};

export default OtpModule;
